import React from 'react'

import Image from 'next/image'

import { HeaderLogoWrapperIcon } from './HeaderLogoWrapperIcon'

import s from './IntroBlockHeaderLogo.module.scss'

export type IntroBlockHeaderLogoProps = {
  icon: string
}

export const IntroBlockHeaderLogo: React.FC<IntroBlockHeaderLogoProps> = ({
  icon,
}) => {
  return (
    <div className={s.IntroBlockHeaderLogo}>
      <div className={s.IntroBlockHeaderLogo__wrapper}>
        <div className={s.IntroBlockHeaderLogo__inner}>
          <Image src={icon} layout="fill" quality={100} alt="" priority />
        </div>
        <HeaderLogoWrapperIcon
          className={s.IntroBlockHeaderLogo__wrapperIcon}
        />
      </div>
    </div>
  )
}
